const getEnv = () => (process.env.REACT_APP_ENV === "prod" ? "live" : "live");
const getDefualtParameters = (language: string, page: string) => ({
  bu: "iavs",
  market: "global",
  pageName: `trelleborg:${language}:iavs:${page ? page : "Home"}`,
  pagePrimaryCategory: page ? page : "Home",
  pageSecondaryCategory: "",
  pageTertiaryCategory: "",
  personaName: "Unassignedprofile",
  language,
});
export const getGA = getDefualtParameters;
export default getEnv;
